// extracted by mini-css-extract-plugin
module.exports = {"searchMapInfoCardMob":"InfoCardComponent_searchMapInfoCardMob__1gU5b"};